import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { catchError, Observable, of, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Ensures users are authenticated and authorized with the api.
 * If not, users will be routed to the login page.
 */
@Injectable({ providedIn: 'root' })
export class LoginGuard {
    constructor(
        private router: Router,
        private auth: AuthService,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const url = state.url;
        return this.auth.isFullyAuthed().pipe(
            tap((result) => {
                if (!result) this.redirectToLogin(url);
            }),
            catchError((error) => {
                console.error(error);
                return of(this.redirectToLogin(url));
            }),
        );
    }

    /**
     * Navigates users to the login screen when they fail authorization
     * and/or authentication for guarded routes.
     * @param url the guarded route that will be used as the start for the
     *  subsequent login redirect which ensures they'll return to the target
     *  route after being successfully fully authed.
     * @private
     */
    private redirectToLogin(url: string) {
        this.auth.redirectUrl = url;
        this.router.navigate(['/login']).then((_) => {
            /* We shouldn't ignore promise resolution but what can we do here? */
        });
        return false;
    }
}
